define('datakit/model',['require','exports','module','underscore','./util/url','backbone','backbone.radio','./base.model','./collection','./mixin/virtual.attributes.mixin','./mixin/child.models.mixin','./mixin/nested.object.mixin','./mixin/url.root.template.mixin','./mixin/fetched.flag.mixin','./mixin/relationships.mixin'],function(require, exports, module){
  var _                      = require('underscore');
  var url                    = require('./util/url');
  var Backbone               = require('backbone');
  var Radio                  = require('backbone.radio');
  var BaseModel              = require('./base.model');
  var DKCollection           = require('./collection');
  var VirtualAttributesMixin = require('./mixin/virtual.attributes.mixin');
  var ChildModelsMixin       = require('./mixin/child.models.mixin');
  var NestedObjectMixin      = require('./mixin/nested.object.mixin');
  var UrlRootTemplateMixin   = require('./mixin/url.root.template.mixin');
  var FetchedFlagMixin       = require('./mixin/fetched.flag.mixin');
  var RelationshipsMixin     = require('./mixin/relationships.mixin');

 (function() {
  var backboneSync = Backbone.sync;
  Backbone.sync = function(method, model, options) {
    options || (options = {});
    options.syncMethod = method;
    return backboneSync.call(this, method, model, options);
  };
 })();

  var Model = BaseModel
  .extend(VirtualAttributesMixin)
  .extend(ChildModelsMixin)
  .extend(NestedObjectMixin)
  .extend(UrlRootTemplateMixin)
  .extend(FetchedFlagMixin)
  .extend(RelationshipsMixin)
  .extend({

    initializeMixin: function() {
      VirtualAttributesMixin.initializeMixin.apply(this, arguments);
      ChildModelsMixin.initializeMixin.apply(this, arguments);
      NestedObjectMixin.initializeMixin.apply(this, arguments);
      UrlRootTemplateMixin.initializeMixin.apply(this, arguments);
      FetchedFlagMixin.initializeMixin.apply(this, arguments);
      RelationshipsMixin.initializeMixin.apply(this, arguments);
    }

  },
  {

    Collection: DKCollection,

    createCollection: function(urlTemplate, options) {
      if (_.isObject(urlTemplate)) {
        options = urlTemplate;
        urlTemplate = null;
      }

      return new this.Collection([], _.extend({
        urlTemplate: urlTemplate
      }, options));
    },

    all: function(options) {
      return new this.Collection([], _.extend({ model: this }, options));
    },

    urlTemplate: function() {
      var args = _.toArray(arguments);
      return function() {
        return url.template.apply(this, args.concat([this._urlParams, this]));
      };
    }

  });

  Model.Collection = Model.Collection.extend({
    model: Model
  });

  Model.extend = function(protoProps, staticProps) {
    var modelClass = Backbone.Model.extend.apply(this, arguments);
    var didDefineNewUrlProperty = (modelClass.Collection.prototype.url !== this.Collection.prototype.url);
    var didDefineNewTemplateProperty = (modelClass.Collection.prototype.urlTemplate !== this.Collection.prototype.urlTemplate);
    var didDefineNewUrlRootProperty = (modelClass.prototype.urlRoot !== this.prototype.urlRoot);
    var didDefineNewUrlRootTemplateProperty = (modelClass.prototype.urlRootTemplate !== this.prototype.urlRootTemplate);
    var extendedParams = {
      model: modelClass
    };

    if (didDefineNewUrlRootTemplateProperty && !didDefineNewTemplateProperty) {
      extendedParams.urlTemplate = modelClass.prototype.urlRootTemplate;
    }
    if (didDefineNewUrlRootProperty && !didDefineNewTemplateProperty && !didDefineNewUrlProperty) {
      extendedParams.url = modelClass.prototype.urlRoot;
    }
    modelClass.Collection = modelClass.Collection.extend(extendedParams);
    return modelClass;
  };

  Radio.channel('models').reply('DataKit.Model', _.constant(Model));

  module.exports = Model;
});

